import React from 'react';
import { Globe } from '@/components/icons';
import { useLanguage } from '@/hooks/use-locale';

export const LanguageSwitcher: React.FC<{ variant?: 'navbar' | 'compact' | 'full' }> = ({
  variant = 'navbar',
}) => {
  const { current, changeLanguage } = useLanguage();

  if (variant === 'full') {
    return (
      <div className="flex items-center gap-2 p-1 bg-secondary/60 rounded-lg border border-border/60">
        <button
          type="button"
          onClick={() => changeLanguage('en')}
          className={`flex-1 py-1.5 px-3 rounded-md text-xs font-semibold transition-all focus-visible:ring-2 focus-visible:ring-primary ${
            current === 'en'
              ? 'bg-card text-foreground shadow-xs'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          🇬🇧 English
        </button>
        <button
          type="button"
          onClick={() => changeLanguage('el')}
          className={`flex-1 py-1.5 px-3 rounded-md text-xs font-semibold transition-all focus-visible:ring-2 focus-visible:ring-primary ${
            current === 'el'
              ? 'bg-card text-foreground shadow-xs'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          🇬🇷 Ελληνικά
        </button>
      </div>
    );
  }

  return (
    <div className="relative inline-flex items-center">
      <button
        type="button"
        onClick={() => changeLanguage(current === 'en' ? 'el' : 'en')}
        className="flex h-9 w-[4.25rem] shrink-0 items-center justify-center gap-1.5 rounded-lg border border-border bg-card px-2.5 text-xs font-medium text-foreground transition-colors shadow-xs hover:bg-secondary cursor-pointer"
        title="Switch Language / Αλλαγή Γλώσσας"
      >
        <Globe className="w-3.5 h-3.5 text-primary shrink-0" />
        <span className="font-bold tracking-wider">{current === 'en' ? 'EN' : 'ΕΛ'}</span>
      </button>
    </div>
  );
};
